import React, { Component } from "react";
import { Navbar } from "react-bootstrap";

import HeaderLinks from "./HeaderLinks.jsx";

/* import logo from "assets/img/logo.png"; */

/* import dashboardRoutes from "routes/dashboard.jsx"; */

class Header extends Component {
  constructor(props) {
    super(props);
    this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this);
    this.state = {
      /* sidebarExists: false */
      sidebarExists: true
    };
  }
  mobileSidebarToggle(e) {
    if (this.state.sidebarExists === false) {
      /* this.setState({
        sidebarExists: true
      }); */
    }
    e.preventDefault();
    document.documentElement.classList.toggle("nav-open");
    var node = document.createElement("div");
    node.id = "bodyClick";
    node.onclick = function() {
      this.parentElement.removeChild(this);
      document.documentElement.classList.toggle("nav-open");
    };
    document.body.appendChild(node);
  }

  render() {
    return (
      <Navbar fluid={true} expand="lg">
        <Navbar.Header>
          <Navbar.Toggle onClick={this.mobileSidebarToggle} />
        </Navbar.Header>
        <Navbar.Collapse>
          <HeaderLinks userName = {this.props.userName} tUser = {this.props.tUser}/>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx